import { createElement, useCallback } from "react";
import fp from "lodash/fp";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { uiActions } from "store";
import { getIsOnline } from "store/ui/ui.reducer";

const OnlineLink = props => {
	const dispatch = useDispatch();
	const isOnline = useSelector(getIsOnline);

	const handleClick = useCallback(
		e => {
			if (!isOnline) {
				dispatch(uiActions.showNoConnectionModal());
				e.preventDefault();
			}

			props.onClick?.(e);
		},
		[isOnline, props, dispatch],
	);

	const link = props.as || Link;
	const restProps = fp.unset("as", props);
	return createElement(link, { ...restProps, onClick: handleClick });
};

export default OnlineLink;
